const nav = [
  { label: "首页", href: "#top" },
  { label: "投稿方式", href: "#methods" },
  { label: "投稿流程", href: "#flow" },
  { label: "投稿守则", href: "#tips" },
  { label: "常见问题", href: "#faq" },
  { label: "关于我们", href: "#about" },
];

export default function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer className="bg-primary-950 text-background-100">
      <div className="mx-auto max-w-7xl px-4 py-14 md:px-6">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-3">
          <div className="md:col-span-2">
            <div className="flex items-center gap-2.5">
              <span className="flex h-10 w-10 items-center justify-center rounded-full bg-accent-500 text-background-50">
                <i className="ri-chat-3-fill text-lg" aria-hidden="true"></i>
              </span>
              <span className="font-heading text-xl font-bold text-background-50">
                瓜田投递<span className="text-accent-400">站</span>
              </span>
            </div>
            <p className="mt-4 max-w-xl text-sm leading-relaxed text-background-100/75">
              一份持续维护的吃瓜投稿指南，汇总当前开放的微信、邮箱、链接与社群投稿渠道，帮你选对最快路径，把瓜料放心递到编辑手上。
            </p>
            <div className="mt-5 flex flex-wrap items-center gap-3 text-xs">
              <span className="inline-flex items-center gap-1.5 whitespace-nowrap rounded-full bg-background-50/10 px-3 py-1.5">
                <i className="ri-check-double-line text-accent-400" aria-hidden="true"></i>
                入口真实可查
              </span>
              <span className="inline-flex items-center gap-1.5 whitespace-nowrap rounded-full bg-background-50/10 px-3 py-1.5">
                <i className="ri-check-double-line text-accent-400" aria-hidden="true"></i>
                信息求新求准
              </span>
              <span className="inline-flex items-center gap-1.5 whitespace-nowrap rounded-full bg-background-50/10 px-3 py-1.5">
                <i className="ri-check-double-line text-accent-400" aria-hidden="true"></i>
                真实为先、守好边界
              </span>
            </div>
          </div>

          <div>
            <h3 className="text-sm font-semibold uppercase tracking-wider text-background-50">快捷导航</h3>
            <div className="mt-4 flex flex-col gap-2.5">
              {nav.map((l) => (
                <a
                  key={l.href}
                  href={l.href}
                  className="inline-flex w-fit items-center gap-2 text-sm text-background-100/80 transition-colors hover:text-accent-400"
                >
                  <i className="ri-arrow-right-up-line text-xs" aria-hidden="true"></i>
                  {l.label}
                </a>
              ))}
            </div>
          </div>
        </div>

        <div className="mt-10 flex flex-col gap-3 border-t border-background-50/10 pt-6 sm:flex-row sm:items-center sm:justify-between">
          <p className="text-xs text-background-100/60">
            © {year} 瓜田投递站 · 本页仅作投稿渠道信息整理与使用说明，请务必核实信息来源并尊重他人隐私。
          </p>
          <p className="flex items-center gap-1.5 text-xs text-background-100/60">
            <i className="ri-heart-line text-primary-300" aria-hidden="true"></i>
            理性吃瓜 · 善意投稿
          </p>
        </div>
      </div>
    </footer>
  );
}